<template>
    <div class="text-xs-center">
        <v-dialog
                v-model="active"
                persistent
                width="300"
        >
            <v-card
                    color="white"
            >
                <v-card-text>
                    Espere por favor...
                    <v-progress-linear
                            indeterminate
                            color="primary"
                            class="mb-0"
                            height="2"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

    import { mapState, mapMutations } from 'vuex'

    export default{
        name: 'LoadingSpinner',
        props: [],
        computed:{
            ...mapState(['loader']),
            active:{
                get(){
                    return this.loader
                },
                set(val){
                    if(val === true){
                        this.showLoader()
                    }else{
                        this.hideLoader()
                    }
                }
            }
        },
        methods:{
                ...mapMutations(['showLoader', 'hideLoader'])
        }
    }
</script>

<style scoped>
    .modal-loader-wrap{
        position: fixed;
        top:0,

    }
</style>